import React from 'react';

// Components
import Home from 'components/Home';

const HomePage = () => <Home isAdmin={false} />;

export default HomePage;
